<div class="card-freeze-body">
  <ng-container *ngIf="reasons$ | async as reason; else loading">
    <app-alert
      style="margin-bottom: 40px"
      class="flex-col-container mt-32"
      type="warning"
      icon="warning_amber"
      lineHeight="lh-1"
      [message]=" alertMessage | translate">
    </app-alert>

    <p class="my-10">{{ 'MODAL_CARDS.STATEMENT' | translate}}</p>

    <div class="p-16 flex-row-container items-center b-0-5 rounded">
      <img class="mr-8 w40" [src]="'/assets/'+imagesCard[contractType][cardType]" [alt]="'contract-' + currentCard?.type?.toLowerCase()" />
      <div class="flex-col-container start flex-1 ml-4">
        <span>{{ 'MODAL_CARDS.'+contractType | translate}}</span>
        <span class="fw-500">•••• {{ currentCard?.last_digits }}</span>
      </div>
      <app-read-only
        [descColor]="currentCard?.state === FROOZEN_STATE ? 'froozen' : 'active'"
        [applyBorderBottom]="false"
        [value]="currentCard?.state"></app-read-only>
    </div>

    <form class="w-95 mt-10 m-auto" [formGroup]="freezeCardForm">
      <mat-form-field class="w-all mt-15 px-8">
        <mat-label>{{ 'MODAL_CARDS.SELECT' | translate}}</mat-label>
        <mat-select class="select-padding" formControlName="reason">
          <mat-option *ngFor="let item of reason" [value]="item.value"> {{ item.value }} </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </ng-container>

  <ng-template #loading>
    <app-skeleton-container [errorMessage]="this.errorMessage" [errorThrown]="this.errorThrown">
      <div class="flex-row-container gap-16">
        <div class="flex-col-container flex-1">
          <app-skeleton-text height="64px" width="100%" [count]="1"></app-skeleton-text>
          <app-skeleton-text className="mt-16" height="32px" width="100%" [count]="1"></app-skeleton-text>
          <app-skeleton-text className="mt-16" height="72px" width="100%" [count]="1"></app-skeleton-text>
          <app-skeleton-text className="mt-16" height="32px" width="100%" [count]="1"></app-skeleton-text>
        </div>
      </div>
    </app-skeleton-container>
  </ng-template>
</div>
